// extracted by mini-css-extract-plugin
module.exports = {"containerStickyButtons":"SimilarsModal_containerStickyButtons__Zv6vy","containerStickyButtonsMobile":"SimilarsModal_containerStickyButtonsMobile__veUK_"};